<template>
  <VerificationList />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import VerificationList from "@/components/Verification/VerificationList.vue";

export default defineComponent({
  name: "VerificationListPage",
  components: { VerificationList },
});
</script>
